import { Link } from "react-router-dom";

import { ROUTES, GALLERY_PREVIEW_SMALL_COUNT } from "~/const";
import { getLink, trans } from "~/providers/lang";
import { getSmallPhoto, getFileName } from "~/utils/photo";
import { mainStore } from "~/stores/main";
import ArrowRight from "../ArrowRight";

import "./style.less";

export default function GalleryPreview() {
	const pageData = mainStore(state => state.data.pageData);
	const weddingPhotos = pageData.photos.wedding[0].slice(0, GALLERY_PREVIEW_SMALL_COUNT);
	const formalPhotos = pageData.photos.formal[0].slice(0, GALLERY_PREVIEW_SMALL_COUNT);
	const actionPhotos = pageData.photos.action[0].slice(0, GALLERY_PREVIEW_SMALL_COUNT);

	const items = [{
		link: `${getLink(ROUTES.galleryWedding)}?strana=1&fotka=${getFileName(weddingPhotos[0].photo)}`,
		img: getSmallPhoto(weddingPhotos[0]),
	}, {
		link: `${getLink(ROUTES.galleryWedding)}?strana=1&fotka=${getFileName(weddingPhotos[1].photo)}`,
		img: getSmallPhoto(weddingPhotos[1]),
	}, {
		link: `${getLink(ROUTES.galleryFormal)}?strana=1&fotka=${getFileName(formalPhotos[0].photo)}`,
		img: getSmallPhoto(formalPhotos[0]),
	}, {
		link: `${getLink(ROUTES.galleryFormal)}?strana=1&fotka=${getFileName(formalPhotos[1].photo)}`,
		img: getSmallPhoto(formalPhotos[1]),
	}, {
		link: `${getLink(ROUTES.galleryAction)}?strana=1&fotka=${getFileName(actionPhotos[0].photo)}`,
		img: getSmallPhoto(actionPhotos[0]),
	}, {
		link: `${getLink(ROUTES.galleryAction)}?strana=1&fotka=${getFileName(actionPhotos[1].photo)}`,
		img: getSmallPhoto(actionPhotos[1]),
	}];

	return <div className="gallery-preview top-shadow">
		<h3>
			{trans('home.gallery.title')}
		</h3>
		<div className="gallery-images">
			{items.map(item => <Link to={item.link} key={item.img}>
				<span className="preview-mini-cover">
					<img src={item.img} alt="" />
				</span>
			</Link>)}
			<Link to={getLink(ROUTES.galeries)}>
				<span className="preview-mini-cover last">
					<ArrowRight className="gallery-images-preview" size="small" />
				</span>
			</Link>
		</div>
	</div>;
}
